import { useEffect } from 'react';
import trackEligibilityCodeExtra from '../../../extra/trackEligibilityCodeExtra.js';
import {
  always,
  and,
  cond,
  gt
} from 'ramda';
import getExtraLimitsAge from '../../../extra/getExtraAgeLimits.js';
import { birthdateFromAge } from '@@serverHelpers/index.mjs';
import { useAnalytics } from '@@app/context/analytics-context.js';

const useBirthDate = ({
  getMiddleNumber,
  getMiddleText,
  effectDate,
  errors,
  context
}) => {
  const { trackEvent } = useAnalytics();

  const { minCustomerAge, maxCustomerAge, customerAgeInfoText } = getExtraLimitsAge(
    getMiddleNumber,
    getMiddleText
  );

  let maxBirthDate = null;
  if (minCustomerAge > -1) {
    maxBirthDate = birthdateFromAge(
      minCustomerAge,
      effectDate,
      getMiddleText('ADHERENT_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
  }
  let minBirthDate = null;
  if (maxCustomerAge > -1) {
    minBirthDate = birthdateFromAge(
      maxCustomerAge,
      effectDate,
      getMiddleText('ADHERENT_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
  }

  const customerAgeTooltipText = cond([
    [() => and(gt(minCustomerAge, -1), gt(maxCustomerAge, -1)), always(customerAgeInfoText)],
    [
      () => gt(maxCustomerAge, -1),
      always(getMiddleText('ADHERENT_DATE_NAISSANCE_AGE_MAXIMUM_INFO', { maxCustomerAge }))
    ],
    [() => gt(minCustomerAge, -1), always(customerAgeInfoText)]
  ])();

  const birthDateErrorMessage = errors?.customer?.birthDate?.message;

  useEffect(() => {
    if (birthDateErrorMessage) {
      trackEvent('eligibility', trackEligibilityCodeExtra(context));
    }
  }, [birthDateErrorMessage]);

  return {
    minBirthDate,
    maxBirthDate,
    customerAgeTooltipText,
    minCustomerAge,
    maxCustomerAge,
    customerAgeInfoText
  };
};

export default useBirthDate;
